document.addEventListener('DOMContentLoaded', function() {
  // Function to customize the Recurpay widget
  function customizeRecurpay() {
    const widget = document.querySelector('.recurpay__widget');
    if (!widget) return false;
    
    // Get the containers
    const subscriptionContainer = document.querySelector('.recurpay__widget_container[data-type="subscription-purchase"]');
    const onetimeContainer = document.querySelector('.recurpay__widget_container[data-type="onetime-purchase"]');
    
    if (!subscriptionContainer || !onetimeContainer) return false;
    
    // Rename the options
    subscriptionContainer.querySelector('.recurpay__group_title').textContent = 'Suscripción (recíbelo recurrentemente)';
    onetimeContainer.querySelector('.recurpay__group_title').textContent = 'Pedido único';
    
    // Add POPULAR tag to subscription (only if it doesn't exist)
    if (!document.querySelector('.popular-tag')) {
      const popularTag = document.createElement('div');
      popularTag.className = 'popular-tag';
      popularTag.innerHTML = '* POPULAR';
      subscriptionContainer.insertBefore(popularTag, subscriptionContainer.firstChild);
    }
    
    // Add bullet points to subscription if they don't exist
    if (!subscriptionContainer.querySelector('.subscription-benefits')) {
      const benefitsHTML = `
        <ul class="subscription-benefits">
          <li>Ahorra por cada bolsa</li>
          <li>Cambia fácilmente de sabor o cantidad</li>
          <li>Cancela cuando quieras</li>
        </ul>
      `;
      
      const contentWrapper = subscriptionContainer.querySelector('.recurpay__group_content_wrapper');
      if (contentWrapper) {
        // Find the frequency selector to insert before it
        const frequencySelector = contentWrapper.querySelector('.recurpay__group_frequency');
        if (frequencySelector) {
          frequencySelector.insertAdjacentHTML('beforebegin', benefitsHTML);
        } else {
          contentWrapper.insertAdjacentHTML('afterbegin', benefitsHTML);
        }
      }
    }
    
    // Change button text for cart
    const actionButtons = document.querySelectorAll('.recurpay__action button');
    actionButtons.forEach(button => {
      button.textContent = 'Añadir al carrito';

        // Add the text below the button
      const buttonContainer = button.closest('.recurpay__action');
      if (buttonContainer && !buttonContainer.querySelector('.recurpay-message')) {
        const messageElement = document.createElement('div');
        messageElement.className = 'recurpay-message';
        messageElement.textContent = 'Sin compromisos, cancela cuando quieras Y ahorra10%';
        messageElement.style.fontSize = '12px';
        messageElement.style.marginTop = '5px';
        messageElement.style.textAlign = 'center';
        buttonContainer.appendChild(messageElement);
      }
    });
    
    // Move one-time purchase to the top
    widget.prepend(onetimeContainer);
    
    // TARGETED REMOVAL of smiley face only
    // Find the smiley by looking for its container or the SVG itself
    const smileFace = subscriptionContainer.querySelector('svg');
    if (smileFace) {
      // Find the container - usually a div that contains the SVG and text
      let container = smileFace.closest('div');
      if (container && 
          (container.textContent.includes('Sin compromisos') || 
           container.textContent.includes('cancela cuando'))) {
        container.remove();
      } else {
        // If we can't find a container with the text, just remove the SVG
        smileFace.remove();
      }
    }
    
    // Look for text nodes containing the "Sin compromisos" text without removing other content
    const paragraphs = subscriptionContainer.querySelectorAll('p');
    paragraphs.forEach(p => {
      if (p.textContent.includes('Sin compromisos') || 
          p.textContent.includes('cancela cuando')) {
        p.remove();
      }
    });
    
    return true;
  }
  
  // Initial attempt to customize
  if (!customizeRecurpay()) {
    const checkExist = setInterval(function() {
      if (customizeRecurpay()) {
        clearInterval(checkExist);
      }
    }, 100);
    
    // Stop checking after 5 seconds
    setTimeout(function() {
      clearInterval(checkExist);
    }, 5000);
  }
  
  // Run after any AJAX event
  $(document).ajaxComplete(function() {
    customizeRecurpay();
  });
  
  // Run again after a short delay to catch any dynamic changes
  setTimeout(customizeRecurpay, 1000);
  setTimeout(customizeRecurpay, 2000);
});